import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';

@Pipe({ name: 'fieldValue' })
export class FieldValuePipe implements PipeTransform {
  transform(data: unknown, field: string | undefined): string {
    if (!field) return '';
    const record = data as Record<string, unknown>;
    const value = record[field];
    if (value == null) return '';
    if (value instanceof Date) {
      return formatDate(value, 'yyyy-MM-dd HH:mm', 'en');
    }
    if (typeof value === 'string' && this.isIsoDate(value)) {
      return formatDate(value, 'yyyy-MM-dd HH:mm', 'en');
    }
    if (typeof value === 'object') return '';
    return `${value as string | number | boolean}`;
  }

  private isIsoDate(value: string): boolean {
    const parsed = Date.parse(value);
    return !Number.isNaN(parsed) && /^\d{4}-\d{2}-\d{2}/.test(value);
  }
}
